import { DataClassName } from '@/Data/const'
import { SchemaAttributes } from '@/Data/types'
import { getSchemaName } from '@/utils/dataClassMap'
import { getSchema } from '@/utils/getSchema'
import { reportError } from '@/utils/reportError'

/** Attribute of the activity schema that enumerates the activity types. */
const ACTIVITY_TYPE_ATTRIBUTE = 'type'

/**
 * Whether the activity schema offers types to filter by.
 *
 * `TypeFilter` renders nothing while the schema is unavailable or lists no
 * types, so a filter panel whose only field is the type filter would come up
 * empty. Callers use this to hide the panel instead (CRM-1272).
 *
 * @returns `true` when at least one activity type is available.
 */
export const hasActivityTypeOptions = (): boolean => {
  const { schema, error } = getSchema(getSchemaName(DataClassName.ACTIVITY))
  if (error) reportError(error)
  if (!schema) return false

  const attributes = schema.get('attributes') as SchemaAttributes

  return !!attributes?.[ACTIVITY_TYPE_ATTRIBUTE]?.enumValues?.length
}
